/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function ShieldCheck(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M208.00146,40h-160a16.02085,16.02085,0,0,0-16,16v58.66406c0,89.46094,75.82032,119.125,91.03125,124.16406a15.45824,15.45824,0,0,0,9.9375,0c15.20313-5.03906,91.03125-34.69531,91.03125-124.16406V56A16.02084,16.02084,0,0,0,208.00146,40ZM177.5249,109.78906l-58.67187,56a8.00489,8.00489,0,0,1-11.04688,0l-29.32812-28A8.00135,8.00135,0,1,1,89.5249,126.21094l23.80469,22.72656L166.478,98.21094a8.00135,8.00135,0,1,1,11.04687,11.57812Z" />
    </Svg>
  );
}

export default ShieldCheck;
